import FileEntry from './file-entry'

export const existingFilesListComponents = {
  fileEntry: FileEntry,
}
